
import { Component, Vue } from 'vue-property-decorator'
import { Detail } from '../../types/insectPests'
import { FileInfo } from '@/types/common'

@Component({
  filters: {
    imgListFilter (arr: Array<FileInfo>) {
      return arr.map(item => {
        return item.filePrefix + item.fileUrl
      })
    }
  }
})
export default class InsectPestsDetail extends Vue {
  private tabList = ['识别特征', '发生规律', '防治方法', '危害虫态及危害状', '参考文献']
  private tabIndex = '0'
  private info: Detail | {} = {}
  get pestsId () {
    return this.$route.params.id || ''
  }

  created () {
    if (this.pestsId) {
      this.getDetail()
    }
  }

  getDetail () {
    this.$axios.get(this.$apis.insectPests.selectPestsDetail, {
      pestsId: this.pestsId
    }).then(res => {
      this.info = res
    })
  }
}
